import React from 'react';

import SEO from '../components/SEO';

const TermsOfUse: React.FC = () => {
    return (
        <div className="min-h-screen bg-brand-light pt-32 pb-24 px-4 md:px-8">
            <SEO
                title="Kullanım Şartları"
                description="Pato Yazılım web sitesi kullanım şartları ve yasal uyarılar."
                link="/kullanim-sartlari"
                noIndex={true}
            />
            <div className="container mx-auto max-w-4xl bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-gray-100">
                <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
                    KULLANIM ŞARTLARI
                </h1>

                <div className="prose max-w-none text-gray-700">
                    <p className="font-medium text-gray-800">Son Güncelleme: 10.02.2026</p>

                    <p>
                        Bu web sitesine (“Site”) erişen veya Site’yi herhangi bir şekilde kullanan tüm ziyaretçiler (“Kullanıcı”), aşağıdaki Kullanım Şartları’nı okumuş, anlamış ve kabul etmiş sayılır. Bu şartları kabul etmiyorsanız Site’yi kullanmayı derhal bırakınız.
                    </p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">1. TARAFLAR VE BİLGİLER</h2>
                    <p>Bu Kullanım Şartları, Site’nin sahibi ve işletmecisi olan:</p>
                    <ul className="list-none pl-0 mt-2 space-y-1">
                        <li><strong>Ceren Tekin Bilgin - Pato Yazılım</strong></li>
                        <li><strong>Adres:</strong> Bozkurt Mah. Seymen Sk. No:43 D:3, 34375 Şişli/İstanbul</li>
                        <li><strong>E-posta:</strong> info@patoyazilim.com</li>
                    </ul>
                    <p className="mt-2">ile Site’yi ziyaret eden tüm Kullanıcılar arasında hüküm doğurur. Bu metin, herhangi bir hizmet satın alımına ilişkin sözleşme niteliğinde olmayıp, yalnızca Site kullanımına ilişkin genel koşulları düzenlemektedir.</p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">2. HİZMETLERİN KAPSAMI</h2>
                    <p>
                        Site’de yazılım geliştirme, danışmanlık ve dijital çözümlere ilişkin bilgiler sunulmaktadır. Pato Yazılım, Site’de yer alan içerikleri, hizmet açıklamalarını ve ilgili bilgileri önceden bildirmeden değiştirme, güncelleme, askıya alma veya tamamen kaldırma hakkını saklı tutar.
                    </p>
                    <p>Site’de yer alan hiçbir bilgi, doğrudan bir teklif veya taahhüt niteliği taşımaz.</p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">3. FİKRİ MÜLKİYET HAKLARI</h2>
                    <p>
                        Site’de yer alan tüm içerikler (metinler, grafikler, logolar, tasarımlar, yazılım kodları, görseller, videolar ve diğer tüm materyaller) Ceren Tekin Bilgin - Pato Yazılım’ın münhasır mülkiyetindedir ve ulusal/uluslararası fikri mülkiyet hukuku kapsamında korunmaktadır.
                    </p>
                    <p>Aşağıdaki fiiller Pato Yazılım’ın açık yazılı izni olmadan yasaktır:</p>
                    <ul className="list-disc pl-5">
                        <li>Site içeriğinin herhangi bir şekilde kopyalanması, çoğaltılması veya yayılması</li>
                        <li>Ticari amaçla kullanılması</li>
                        <li>İçeriğin değiştirilmesi, işlenmesi veya türevlerinin oluşturulması</li>
                        <li>Otomatik veri toplama yöntemleri (bot, spider, scraper vb.) kullanılması</li>
                    </ul>
                    <p>Aksi hallerde Pato Yazılım, tüm hukuki ve cezai haklarını saklı tutar.</p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">4. KULLANICI YÜKÜMLÜLÜKLERİ</h2>
                    <p>Kullanıcı, Site’yi kullanırken aşağıdaki yükümlülüklere uymayı kabul eder:</p>
                    <ul className="list-disc pl-5">
                        <li>Siteyi yürürlükteki hukuk kurallarına aykırı amaçlarla kullanmamak.</li>
                        <li>Üçüncü kişilerin kişilik, telif veya diğer haklarını ihlal etmemek.</li>
                        <li>Virüs, trojan, kötü amaçlı yazılım gönderme veya sistem işleyişine müdahale girişiminde bulunmamak.</li>
                        <li>Site’nin güvenlik açıklarını araştırmaya, test etmeye veya taramaya teşebbüs etmemek.</li>
                        <li>Spam, yanıltıcı bilgi, hakaret, tehdit veya uygunsuz içerik iletmemek.</li>
                        <li>Site’ye orantısız yük bindirecek robot, bot veya otomatik sistemler kullanmamak.</li>
                    </ul>
                    <p>Bu yükümlülüklerin ihlali halinde Kullanıcı, doğabilecek tüm zararlardan bizzat sorumlu olduğunu kabul eder.</p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">5. SORUMLULUK REDDİ (DISCLAIMER)</h2>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">5.1. “Olduğu Gibi” Sunum</h3>
                    <p>Site ve içerisindeki bilgiler “olduğu gibi” (as is) sunulmaktadır. Pato Yazılım aşağıdakiler için herhangi bir garanti vermez:</p>
                    <ul className="list-disc pl-5">
                        <li>Sitenin kesintisiz veya hatasız çalışacağı</li>
                        <li>İçeriklerin güncel, doğru veya eksiksiz olduğu</li>
                        <li>Site’nin virüs veya zararlı yazılım içermediği</li>
                    </ul>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">5.2. Dolaylı Zararlar</h3>
                    <p>
                        Kullanıcının Site’yi kullanması nedeniyle ortaya çıkabilecek doğrudan veya dolaylı zararlardan Pato Yazılım sorumlu tutulamaz.
                        Buna; kar kaybı, veri kaybı, iş durması, donanım hasarı vb. dahildir.
                    </p>

                    <h3 className="text-lg font-bold text-gray-900 mt-6 mb-2">5.3. Üçüncü Taraf Bağlantılar</h3>
                    <p>
                        Site’de üçüncü kişilere ait web sitelerine bağlantılar bulunabilir.
                        Bu sitelerin içeriklerinden, güvenliğinden veya kullanım sonuçlarından İşletmemiz sorumlu değildir.
                    </p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">6. GİZLİLİK VE KİŞİSEL VERİLER</h2>
                    <p>
                        Kullanıcıların kişisel verilerinin işlenmesi, korunması ve aktarımına ilişkin hükümler, Site’de yayınlanan “Gizlilik Politikası ve KVKK Aydınlatma Metni” kapsamındadır.
                        Site’yi kullanarak ilgili metni de kabul etmiş sayılırsınız. Pato Yazılım şu anda kullanıcılarına ticari elektronik ileti (bülten, reklam mesajı) göndermemektedir.
                    </p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">7. DEĞİŞİKLİK HAKKI</h2>
                    <p>
                        Pato Yazılım, bu Kullanım Şartları’nı dilediği zaman tek taraflı olarak güncelleyebilir.
                        Güncel metin, Site’de yayınlandığı anda yürürlüğe girer. Kullanıcıların bu sayfayı düzenli olarak kontrol etmesi önerilir.
                    </p>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">8. UYUŞMAZLIKLARIN ÇÖZÜMÜ</h2>
                    <p>Bu Kullanım Şartları’nın yorumlanması veya uygulanmasından doğabilecek ihtilaflarda:</p>
                    <ul className="list-disc pl-5">
                        <li>Türkiye Cumhuriyeti kanunları uygulanır.</li>
                        <li>İstanbul Merkez (Çağlayan) Mahkemeleri ve İcra Daireleri yetkilidir.</li>
                    </ul>

                    <h2 className="text-xl font-bold text-gray-900 mt-8 mb-4">9. İLETİŞİM</h2>
                    <p>Bu Kullanım Şartları hakkında her türlü soru ve görüşleriniz için bize ulaşabilirsiniz:</p>
                    <ul className="list-none pl-0 mt-2 space-y-1">
                        <li><strong>Ceren Tekin Bilgin - Pato Yazılım</strong></li>
                        <li><strong>Adres:</strong> Bozkurt Mah. Seymen Sk. No:43 D:3, 34375 Şişli/İstanbul</li>
                        <li><strong>E-posta:</strong> info@patoyazilim.com</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default TermsOfUse;
